import React from "react";
import { useTranslation } from "react-i18next";
import { SubPage, FullDivider } from "./SubPage";

export function Careers() {
  const { t } = useTranslation("careers");
  const values = t("values", { returnObjects: true }) as { label: string; desc: string }[];
  const roles = t("roles", { returnObjects: true }) as { title: string; type: string; description: string; requirements: string[] }[];

  return (
    <SubPage title={t("title")} subtitle={t("subtitle")} heroImage="/assets/team/founder-desk-portrait.png">

      <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-grey-800">
        <div className="bg-grey-975 px-5 sm:px-8 md:px-[66px] py-10 md:py-12">
          <h3 className="text-base font-semibold text-white mb-3">{t("howHeading")}</h3>
          <p className="text-sm text-grey-400 leading-relaxed">{t("howBody")}</p>
        </div>
        <div className="bg-grey-975 px-5 sm:px-8 md:px-[66px] py-10 md:py-12">
          <h3 className="text-base font-semibold text-white mb-4">{t("valuesHeading")}</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-px bg-grey-800">
            {values.map((v) => (
              <div key={v.label} className="bg-grey-975 pr-4 pb-4 first:pl-0">
                <p className="text-sm text-white/70 font-medium mb-1">{v.label}</p>
                <p className="text-[11px] text-white/30 leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
      <FullDivider />

      <div className="relative">
        <div className="absolute inset-0 dot-grid-sm dot-fade-b pointer-events-none" style={{ opacity: 0.15 }} />
        <div className="px-5 sm:px-8 md:px-[66px] pt-12 md:pt-16 pb-4 relative">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-3">{t("rolesHeading")}</h2>
        </div>
        <FullDivider />
        <div className="grid grid-cols-1 gap-px bg-grey-800 border-t border-grey-800 relative">
          {roles.map((role) => (
            <div key={role.title} className="bg-grey-975 px-5 sm:px-8 md:px-[66px] py-10 md:py-12">
              <div className="flex items-center justify-between mb-1">
                <h3 className="text-base font-semibold text-white">{role.title}</h3>
                <span className="text-[9px] uppercase tracking-widest text-white/30 font-medium px-2 py-0.5 bg-white/[0.04]">
                  {role.type}
                </span>
              </div>
              <p className="text-xs text-white/40 leading-relaxed mb-4">{role.description}</p>
              <p className="text-[10px] uppercase tracking-widest text-white/30 mb-2">{t("requirementsLabel")}</p>
              <ul className="space-y-1.5">
                {role.requirements.map((req) => (
                  <li key={req} className="flex items-start gap-2 text-xs text-white/45">
                    <span className="text-white/20 shrink-0 mt-px">·</span>
                    {req}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <FullDivider />
      <div className="px-5 sm:px-8 md:px-[66px] py-12 md:py-16">
        <h3 className="text-base font-semibold text-white mb-2">{t("ctaHeading")}</h3>
        <p className="text-sm text-grey-400 leading-relaxed">
          {t("ctaBodyBefore")}{" "}
          <a href="mailto:careers@cero-ai.com" className="text-white/60 hover:text-white transition-colors underline underline-offset-2 decoration-white/15 hover:decoration-white/40">
            careers@cero-ai.com
          </a>{" "}
          {t("ctaBodyAfter")}
        </p>
      </div>

    </SubPage>
  );
}
